import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import {
  map,
  distinctUntilChanged,
  tap,
  filter,
  mergeMap
} from 'rxjs/operators';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { GameDayRootReducerState } from '../../../state/root.state';
import { ProfileOverviewState } from '../../../state/profile/state';
import { getProfileState } from '../../../state/data/reducer';
import { InstitutionalProfileData } from '../../models/portfolio';

@Component({
  selector: 'muni-gameday-money-type',
  templateUrl: './money-type.template.html',
  styleUrls: ['./money-type.styles.scss'],
  standalone: false,
})
export class MoneyTypeComponent {
  private readonly loading: Subject<boolean> = new BehaviorSubject<boolean>(
    true
  );

  @ReusableStreamProperty
  public readonly data: Observable<InstitutionalProfileData> = this.store.pipe(
    select(getProfileState),
    tap(({ loading }: ProfileOverviewState) => this.loading.next(loading)),
    filter(
      ({ activeAccount, account }: ProfileOverviewState) =>
        !!activeAccount && !!account
    ),
    distinctUntilChanged(
      (prev: ProfileOverviewState, next: ProfileOverviewState) =>
        prev.activeAccount === next.activeAccount
    ),
    mergeMap(({ activeAccount }: { activeAccount: string }) =>
      this.store.pipe(
        select(getProfileState),
        filter((profile: ProfileOverviewState) => !!profile.account),
        distinctUntilChanged(
          (prev: ProfileOverviewState, next: ProfileOverviewState) =>
            activeAccount === next.account.accountName
        ),
        map(({ account: { moneyType, address } }: ProfileOverviewState) => {
          this.loading.next(false);

          return {
            firmId: null,
            deptBookmgrId: null,
            moneyType: {
              code: moneyType && moneyType.code,
              name: moneyType && moneyType.name
            },
            city: address && address.city,
            state: address && address.state,
            zip: address && address.zip
          };
        })
      )
    ),
    distinctUntilChanged()
  );

  @ReusableStreamProperty
  public readonly isLoading: Observable<
    boolean
  > = this.loading.asObservable().pipe(distinctUntilChanged());

  constructor(private store: Store<GameDayRootReducerState>) {}
}
